import axios from '../axiosApi';
import {
    FETCH_RASPA_RECIPE_USAGE_STATISTICS,

    FETCH_RASPA_RECIPES,
    NEW_RASPA_RECIPE,
    NEW_RASPA_RECIPE_SUCCESS, RECEIVE_RASPA_RECIPE_USAGE_STATISTICS,
    RECEIVE_RASPA_RECIPES,
    IS_FETCHING_GLBRECEITAS,
    RECEIVE_GLBRECEITAS,
    IS_FETCHING_GLB_RECEITA_CATEGORIAS,
    RECEIVE_GLB_RECEITA_CATEGORIAS,
    PATCH_GLB_RECEITA_EHATIVO,
    PATCH_GLB_RECEITA_EHATIVO_SUCCESS,
    IS_FETCHING_GLB_PNEU_MODELOS,
    RECEIVE_GLB_PNEU_MODELOS,
    IS_FETCHING_GLB_PNEU_MEDIDAS,
    RECEIVE_GLB_PNEU_MEDIDAS,
    IS_FETCHING_GLB_BANDAS,
    RECEIVE_GLB_BANDAS
} from "./actionTypes";

export const fetchRaspaRecipes =  () => ({
    type: FETCH_RASPA_RECIPES
});

export const receiveRaspaRecipes = payload => ({
    type: RECEIVE_RASPA_RECIPES,
    payload: payload
});

export const dpnewRaspaRecipe =  () => ({
    type: NEW_RASPA_RECIPE
});

export const dpnewRaspaRecipeSuccess = payload => ({
    type: NEW_RASPA_RECIPE_SUCCESS,
    payload: payload
});

export const dpFetchRaspaRecipeUsageStatistics = () => ({
    type: FETCH_RASPA_RECIPE_USAGE_STATISTICS,
    payload: {
        hourUsageTotals: []
    }
});

export const dpReceiveRaspaRecipeUsageStatistics = payload => ({
    type: RECEIVE_RASPA_RECIPE_USAGE_STATISTICS,
    payload: payload
});


export const getRaspaRecipes = () => {
    return async dispatch => {
        dispatch(fetchRaspaRecipes());
        let payload;
        try {
            const response = await axios.get(`/RaspaRecipes/GetFullData`)
            payload = response.data
        }
        catch(e) {
            payload = { error: true };
        }
        finally {
            dispatch(receiveRaspaRecipes(payload));
        }
    }
};

export const newRaspaRecipe = (raspaRecipe) => {
    return async dispatch => {
        dispatch(dpnewRaspaRecipe());
        let payload;
        try {
            const response = await axios.post(`/RaspaRecipes`, raspaRecipe)
            payload = response.data
        }
        catch(e) {
            payload = { error: true };
        }
        finally {

            dispatch(dpnewRaspaRecipeSuccess(payload));
        }
    }
}

export const getRaspaRecipeUsageStatistics = () => {
    return async (dispatch, getState) => {
        dispatch(dpFetchRaspaRecipeUsageStatistics());

        let countUsage;
        let recipeUsage;
        let sideCorrectionUsage;

        let payload;

        try {
            const { periodMin, periodMax, beforeperiodMin, beforeperiodMax, benchperiodMin, benchperiodMax } = getState().filter;

                let options1 = {
                    "Interval": {
                        "Min": periodMin,
                        "Max": periodMax
                    },
                    "IntervalComparasion": {
                        "Min": beforeperiodMin,
                        "Max": beforeperiodMax
                    },
                    "IntervalBenchmark": {
                        "Min": benchperiodMin,
                        "Max": benchperiodMax
                    }
                }
                console.log('getting raspacycle data');
                const response1 = await axios.get(`/raspa-receitas/contagemUso?intervalo={"min":"${periodMin}","max":"${periodMax}"}`);
                countUsage = response1.data;
            //const response2 = await axios.post(`/raspacycles/RecipeUsage`, options1)
           // recipeUsage = response2.data;
           // const response4 = await axios.post(`/raspacycles/SideCorrectionUsage`, options1)
          //  sideCorrectionUsage = response4.data;




        }
        catch(e) {
            payload = { error: true };
        }
        finally {

            payload = {
                countUsage: countUsage,
                recipeUsage: recipeUsage,
                sideCorrectionUsage: sideCorrectionUsage
            }

            dispatch(dpReceiveRaspaRecipeUsageStatistics(payload));
        }
    }
}

// --- GLB Receita Categorias ---
// Endpoint /glb-raspa-receita-categorias nao existe no backend ainda.
// Por enquanto, tentamos buscar e fallback para array vazio.

export const getGlbReceitaCategorias = () => {
    return async dispatch => {
        dispatch({ type: IS_FETCHING_GLB_RECEITA_CATEGORIAS });
        let payload;
        try {
            const response = await axios.get(`/glb-raspa-receita-categorias`);
            payload = response.data;
        } catch (e) {
            console.error('Error fetching glb receita categorias:', e);
            payload = [];
        } finally {
            dispatch({ type: RECEIVE_GLB_RECEITA_CATEGORIAS, payload });
        }
    }
};

// --- GLB Pneu Modelos (global) ---

export const getGlbPneuModelos = () => {
    return async dispatch => {
        dispatch({ type: IS_FETCHING_GLB_PNEU_MODELOS });
        let payload;
        try {
            const filter = JSON.stringify({ include: [{ relation: 'glbFabricante' }] });
            const response = await axios.get(`/glb-pneu-modelos?filter=${encodeURIComponent(filter)}`);
            payload = response.data;
        } catch (e) {
            console.error('Error fetching glb pneu modelos:', e);
            payload = [];
        } finally {
            dispatch({ type: RECEIVE_GLB_PNEU_MODELOS, payload });
        }
    }
};

// --- GLB Pneu Medidas (global) ---

export const getGlbPneuMedidas = () => {
    return async dispatch => {
        dispatch({ type: IS_FETCHING_GLB_PNEU_MEDIDAS });
        let payload;
        try {
            const response = await axios.get(`/glb-pneu-medidas`);
            payload = response.data;
        } catch (e) {
            console.error('Error fetching glb pneu medidas:', e);
            payload = [];
        } finally {
            dispatch({ type: RECEIVE_GLB_PNEU_MEDIDAS, payload });
        }
    }
};

// --- GLB Bandas (global) ---

export const getGlbBandas = () => {
    return async dispatch => {
        dispatch({ type: IS_FETCHING_GLB_BANDAS });
        let payload;
        try {
            const response = await axios.get(`/glb-bandas`);
            payload = response.data;
        } catch (e) {
            console.error('Error fetching glb bandas:', e);
            payload = [];
        } finally {
            dispatch({ type: RECEIVE_GLB_BANDAS, payload });
        }
    }
};

// --- GLB Receitas (server-side filtered) ---
// Campos usam nomes globais: glbRaspaReceitaCategoriaId, glbPneuModeloId, glbPneuMedidaId, glbBandaId

export const getGlbReceitas = (filters) => {
    return async dispatch => {
        dispatch({ type: IS_FETCHING_GLBRECEITAS });
        let payload;
        try {
            const where = {};
            if (filters.categoriaId) where.glbRaspaReceitaCategoriaId = filters.categoriaId;
            if (filters.modeloId) where.glbPneuModeloId = filters.modeloId;
            if (filters.medidaId) where.glbPneuMedidaId = filters.medidaId;
            if (filters.bandaId) where.glbBandaId = filters.bandaId;
            if (filters.vidaPneuRaspagem !== '' && filters.vidaPneuRaspagem !== null && filters.vidaPneuRaspagem !== undefined) {
                where.vidaPneuRaspagem = Number(filters.vidaPneuRaspagem);
            }
            // Fabricante: nao eh campo direto na receita, filtrar modelos client-side
            if (filters.fabricanteId && !filters.modeloId) {
                if (filters.glbModeloIdsByFabricante && filters.glbModeloIdsByFabricante.length > 0) {
                    where.glbPneuModeloId = { inq: filters.glbModeloIdsByFabricante };
                }
            }

            const loopbackFilter = { where };
            // Limitar resultado se nenhum filtro foi preenchido (protecao contra 100k)
            if (Object.keys(where).length === 0) {
                loopbackFilter.limit = 500;
            }

            const filterParam = JSON.stringify(loopbackFilter);
            console.log('getGlbReceitas filter:', filterParam);
            const response = await axios.get(`/glb-raspa-receitas?filter=${encodeURIComponent(filterParam)}`);
            payload = response.data;
            console.log('getGlbReceitas response count:', payload ? payload.length : 0);
        } catch (e) {
            console.error('Error fetching glb receitas:', e);
            payload = [];
        } finally {
            dispatch({ type: RECEIVE_GLBRECEITAS, payload });
        }
    }
};

// --- PATCH ehAtivo ---

export const patchGlbReceitaEhAtivo = (id, ehAtivo) => {
    return async dispatch => {
        dispatch({ type: PATCH_GLB_RECEITA_EHATIVO, payload: { id, ehAtivo } });
        try {
            await axios.patch(`/glb-raspa-receitas/${id}`, { ehAtivo });
            dispatch({ type: PATCH_GLB_RECEITA_EHATIVO_SUCCESS, payload: { id, ehAtivo } });
        } catch (e) {
            console.error('Error patching glb receita ehAtivo:', e);
            // revert optimistic update
            dispatch({ type: PATCH_GLB_RECEITA_EHATIVO_SUCCESS, payload: { id, ehAtivo: !ehAtivo } });
        }
    }
};
